import styled from '@emotion/styled';
import { CheckIcon } from 'src/assets/icons/CheckIcon';
import { mainColors, dropdown, dropdownWrapper } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import type { StylesConfig } from 'src/components/DropdownWrapper/DropdownWrapper';

interface ButtonWrapperType {
    isDisabled: boolean;
}
export const ButtonWrapper = styled('div', { label: 'ButtonWrapper' })<ButtonWrapperType>`
    ${({ isDisabled }): string => isDisabled === true ? `
    opacity: 0.5;
    ` : `
    `}
`;

export const ButtonTag = styled('button', { label: 'ButtonTag' })`
    user-select: none;
    margin-top: 10px;
    width: 100%;
`;

export const CheckIconWrapper = styled(CheckIcon, { label: 'CheckIconWrapper' })`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 8px;
    fill: ${mainColors.default.dark};
`;

export const OptionWrapper = styled('div', { label: 'OptionWrapper' })<{ isSelected?: boolean }>`
    background-color: ${(props): string => props.isSelected === true ? dropdownWrapper.option.bgColorSelected : dropdownWrapper.option.bgColor};
    color: ${(props): string => props.isSelected === true ? dropdownWrapper.option.txtColorSelected : dropdownWrapper.option.txtColor};
    cursor: pointer;
    display: block;
    min-height: 26px;
    padding: 8px 10px;
    border-bottom: 1px solid ${dropdownWrapper.option.borderColor};
    font-weight: 400;
    white-space: nowrap;
    vertical-align: middle;
    position: relative;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: ${(props): string => props.isSelected === true ? dropdownWrapper.option.bgColorSelected : dropdownWrapper.option.bgColorHover};
        color: ${dropdownWrapper.option.txtColorSelected};
    }
`;

export const Wrapper = styled('div', { label: 'Wrapper' })`
    position: relative;
    margin-bottom: 5px;
`;

export const Label = styled('label', { label: 'Label' })`
    position: absolute;
    top: 0;
    padding: 2px 0 0 10px;
    font-size: 11px;
    color: ${dropdown.label};
    pointer-events: none;
`;

export const ErrorMessage = styled('div', { label: 'ErrorMessage' })`
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.regular};
    line-height: 1.4;
    color: ${mainColors.status.error};
    margin: 8px 0;
`;

export const InputError = styled(ErrorMessage, { label: 'InputError' })`
    font-size: ${fontSize.small};
    flex: 1 0 100%;
    margin: 8px 0 0 0;
`;

export const getCustomDropdownStyles = <Option, IsMulti extends boolean>(): StylesConfig<
    Option,
    IsMulti
> => ({
    singleValue: (base) => ({
        ...base,
        fontWeight: 700,
        fontSize: fontSize.xRegular,
    }),
    placeholder: (base) => ({
        ...base,
        fontSize: fontSize.xRegular,
    }),
});
